import React, { useState } from "react";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import { EyeEmpty, EyeOff } from "iconoir-react";
import {
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  TextField,
} from "@material-ui/core";
import Termdata from "../Terminos/Termdata";
import Swalgeneral from "../../../Landing/General/Swalgeneral";
import StepperComp from "../../../Gerneralcomponents/Stepper/StepperComp";
import md5 from "md5";
import { Loader } from "../../../Loader/Loader";
import { domain } from "../../../Urls/Services/Api_urls";
import Logonew from "../../../assets/LogoNew.webp";
// import Navbar from "../../../Gerneralcomponents/Navbar/Navbar";

export default function Registro(props) {
  // const lowercaseRegex = /(?=.*[a-z])/;
  // const uppercaseRegex = /(?=.*[A-Z])/;
  const numericRegex = /(?=.*[0-9])/;
  const contract = window.sessionStorage.getItem("cont");
  const [showPassword, setShowPassword] = React.useState(false);
  const [showPassword1, setShowPassword1] = React.useState(false);

  const steps0 = [
    { label: "Comprueba tu cobertura", },
    { label: "Selecciona tu paquete", },
    { label: "Registar usuario", },
    { label: "Registrar solicitud", },
  ];

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const url = domain + "/user/register/";
  const [isToggled, setIsToggled] = useState(false);
  const [loading, setLoading] = useState(false);
  let objeto,
    objeto1 = [];

  const registerfuncion = (e) => {
    if (isToggled !== false) {
      try {
        setLoading(true);
        fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(e),
        }).then(async function (response) {
          const respuesta = await response.json();
          if (response.status === 201) {
            window.sessionStorage.setItem("user_creation",  respuesta.user_creation );
            window.sessionStorage.setItem("email", e.username);
            window.sessionStorage.setItem("name", e.name);
            window.sessionStorage.setItem("last_name", e.last_name);
            window.sessionStorage.setItem("cedula", e.dni);
            window.sessionStorage.setItem("celular", e.phone);
            setLoading(false);
            Swal.fire({
              title: "Registro exitoso",
              text: "Verifica tu cuenta en el correo",
              icon: "success",
              showConfirmButton: false,
              timer: 4000,
            }).then(() => {
              window.location.href = props.ruta;
            });
          } else {
            setLoading(false);
            objeto = respuesta;
            objeto1 = Promise.resolve(JSON.stringify(objeto));
            Swalgeneral("Error", "error", "text", objeto1);
          }
        });
      } catch (error) {
        setLoading(false);
        Swal.fire({
          title: "Error!",
          text: "Hubo un error!",
          icon: "error",
          confirmButtonText: "Intentar",

        });
        console.error(error);
      }
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Acepta los terminos y condiciones",
      });
    }
  };

  const { errors, touched, handleChange, handleSubmit } = useFormik({
    initialValues: {
      username: "",
      reusername: "",
      name: "",
      last_name: "",
      password: "",
      rePassword: "",
      phone: "",
      dni: "",
      contract: contract,
    },

    validationSchema: Yup.object({
      username: Yup.string()
        .email("escriba un correo valido")
        .required("campo requerido"),
      reusername: Yup.string()
        .oneOf([Yup.ref("username")], "Los correos deben ser iguales")
        .email("escriba un correo valido")
        .required("campo requerido"),
      name: Yup.string().required("El campo es requerido"),
      last_name: Yup.string().required("El campo es requerido"),
      password: Yup.string()
        .min(6, "La contraseña debe tener minimo 6 digitos")
        .required("El campo es requerido"),
      rePassword: Yup.string()
        .oneOf([Yup.ref("password")], "Las contraseñas deben ser iguales")
        .min(6, "La contraseña debe tener minimo 6 digitos")
        .required("El campo es requerido"),
      phone: Yup.string()
        .matches(numericRegex, "No es un numero valido")
        .min(10, "El telefono debe tener minimo 10 digitos")
        .required("El campo es requerido"),
      dni: Yup.string()
        .min(4, "La Cedula debe tener minimo 7 digitos")
        .required("El campo es requerido"),
    }),

    onSubmit: (formData) => {
      const comparative = md5(formData.dni);
      if (window.sessionStorage.getItem("display") !== null) {
        if (comparative === window.sessionStorage.getItem("display")) {
          registerfuncion(formData);
        } else {
          Swal.fire({
            icon: "error",
            title: "La cedula no coincide con la de tu contrato",
          });
        }
      } else {
        registerfuncion(formData);
      }
    },
  });

  return (
    <> 
      {/* <Navbar /> */}
      {loading && <Loader />}
      <div className="overflow-y-auto h-screen">
        <div className="flex flex-col md:flex-row-reverse w-full items-center justify-center min-h-screen"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 1600 800'%3E%3Cg fill-opacity='0.27'%3E%3Cpath fill='%23f2efeb' d='M486 705.8c-109.3-21.8-223.4-32.2-335.3-19.4C99.5 692.1 49 703 0 719.8V800h843.8c-115.9-33.2-230.8-68.1-347.6-92.2C492.8 707.1 489.4 706.5 486 705.8z'/%3E%3Cpath fill='%23f1eade' d='M1600 0H0v719.8c49-16.8 99.5-27.8 150.7-33.5c111.9-12.7 226-2.4 335.3 19.4c3.4 0.7 6.8 1.4 10.2 2c116.8 24 231.7 59 347.6 92.2H1600V0z'/%3E%3Cpath fill='%23f3e6ce' d='M478.4 581c3.2 0.8 6.4 1.7 9.5 2.5c196.2 52.5 388.7 133.5 593.5 176.6c174.2 36.6 349.5 29.2 518.6-10.2V0H0v574.9c52.3-17.6 106.5-27.7 161.1-30.9C268.4 537.4 375.7 554.2 478.4 581z'/%3E%3Cpath fill='%23f8e3bc' d='M0 0v429.4c55.6-18.4 113.5-27.3 171.4-27.7c102.8-0.8 203.2 22.7 299.3 54.5c3 1 5.9 2 8.9 3c183.6 62 365.7 146.1 562.4 192.1c186.7 43.7 376.3 34.4 557.9-12.6V0H0z'/%3E%3Cpath fill='%23FFE1A7' d='M181.8 259.4c98.2 6 191.9 35.2 281.3 72.1c2.8 1.1 5.5 2.3 8.3 3.4c171 71.6 342.7 158.5 531.3 207.7c198.8 51.8 403.4 40.8 597.3-14.8V0H0v283.2C59 263.6 120.6 255.7 181.8 259.4z'/%3E%3Cpath fill='%23ffd9a9' d='M1600 0H0v136.3c62.3-20.9 127.7-27.5 192.2-19.2c93.6 12.1 180.5 47.7 263.3 89.6c2.6 1.3 5.1 2.6 7.7 3.9c158.4 81.1 319.7 170.9 500.3 223.2c210.5 61 430.8 49 636.6-16.6V0z'/%3E%3Cpath fill='%23ffd1ab' d='M454.9 86.3C600.7 177 751.6 269.3 924.1 325c208.6 67.4 431.3 60.8 637.9-5.3c12.8-4.1 25.4-8.4 38.1-12.9V0H288.1c56 21.3 108.7 50.6 159.7 82C450.2 83.4 452.5 84.9 454.9 86.3z'/%3E%3Cpath fill='%23ffcaae' d='M1600 0H498c118.1 85.8 243.5 164.5 386.8 216.2c191.8 69.2 400 74.7 595 21.1c40.8-11.2 81.1-25.2 120.3-41.7V0z'/%3E%3Cpath fill='%23ffc3b0' d='M1397.5 154.8c47.2-10.6 93.6-25.3 138.6-43.8c21.7-8.9 43-18.8 63.9-29.5V0H643.4c62.9 41.7 129.7 78.2 202.1 107.4C1020.4 178.1 1214.2 196.1 1397.5 154.8z'/%3E%3Cpath fill='%23FFBDB2' d='M1315.3 72.4c75.3-12.6 148.9-37.1 216.8-72.4h-723C966.8 71 1144.7 101 1315.3 72.4z'/%3E%3C/g%3E%3C/svg%3E")`,
          backgroundAttachment: 'fixed',
          backgroundSize: 'cover'
        }}>
          <div className="container-fluid flex flex-col md:flex-row-reverse w-full items-center justify-center gap-x-4 max-w-screen-lg mx-auto">
          <div className="w-full md:w-1/3 p-2"
          style={{ display: props.stepper }}>
          <StepperComp
            steps={steps0}
            activeStep={2}
            orientation={"vertical"}
            alternativeLabel={false}
          />
          </div>
          <div 
            className="w-full md:w-2/3 p-2"
            
          >
            <form className="w-full max-w-md" onSubmit={handleSubmit}>
              <div className="shadow-md backdrop-blur-sm rounded-3xl bg-white/70 p-8">
                <div className="flex justify-center mb-6">
                  <a href="/">
                    <img className="w-52" src={Logonew} alt="Logo"/>
                  </a>
                </div>
                
                <h3 className="text-xl font-bold text-center mb-8">
                  Registro de usuario
                </h3>
                

                <div className="space-y-5">
                  <TextField
                    id="username"
                    label="Correo"
                    variant="standard"
                    name="username"
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                  {errors.username && touched.username && (
                    <p className="mt-1 text-sm text-red-600">{errors.username}</p>
                  )}

                  <TextField
                    id="reusername"
                    label="Confirmar Correo"
                    variant="standard"
                    name="reusername"
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                  {errors.reusername && touched.reusername && (
                    <p className="mt-1 text-sm text-red-600">{errors.reusername}</p>
                  )}

                  <TextField
                    label="Celular"
                    variant="standard"
                    name="phone"
                    id="phone"
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                  {errors.phone && touched.phone && (
                    <p className="mt-1 text-sm text-red-600">{errors.phone}</p>
                  )}

                  <TextField
                    label="Nombre"
                    variant="standard"
                    name="name"
                    id="name"
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                  {errors.name && touched.name && (
                    <p className="mt-1 text-sm text-red-600">{errors.name}</p>
                  )}

                  <TextField
                    label="Apellido"
                    variant="standard"
                    name="last_name"
                    id="last_name"
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                  {errors.last_name && touched.last_name && (
                    <p className="mt-1 text-sm text-red-600">{errors.last_name}</p>
                  )}

                  <FormControl fullWidth>
                    <InputLabel htmlFor="standard-adornment-password">
                      Contraseña *
                    </InputLabel>
                    <Input
                      id="standard-adornment-password"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      onChange={handleChange}
                      required
                      variant="standard"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <EyeOff /> : <EyeEmpty />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  {errors.password && touched.password && (
                    <p className="mt-1 text-sm text-red-600">{errors.password}</p>
                  )}

                  <FormControl fullWidth>
                    <InputLabel htmlFor="confirm-password">
                      Confirmar Contraseña *
                    </InputLabel>
                    <Input
                      id="confirm-password"
                      type={showPassword1 ? "text" : "password"}
                      name="rePassword"
                      onChange={handleChange}
                      required
                      variant="standard"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword1}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword1 ? <EyeOff /> : <EyeEmpty />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  {errors.rePassword && touched.rePassword && (
                    <p className="mt-1 text-sm text-red-600">{errors.rePassword}</p>
                  )}

                  <TextField
                    label="Documento de identidad"
                    variant="standard"
                    name="dni"
                    id="dni"
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                  {errors.dni && touched.dni && (
                    <p className="mt-1 text-sm text-red-600">{errors.dni}</p>
                  )}
                </div>

                {/* Términos y condiciones */}
                <div className="flex inline-flex items-center gap-3 mt-8 mb-6">
                  <input
                    className="h-5 w-5"
                    type="checkbox"
                    onClick={() => setIsToggled(!isToggled)}
                  />
                  <button
                    type="button"
                    className="text-red-950/70 hover:text-red-600 focus:outline-none"
                    onClick={Termdata}
                  >
                    Términos y condiciones
                  </button>
                </div>
                
                {/* Botón de registro */}
                <button 
                  className="w-full py-3 text-white rounded-xl bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-300" 
                  type="submit"
                >
                  Registrar
                </button>
                
                {/* Enlaces */}
                <div className="flex flex-col items-center space-y-2 mt-6">
                  <a className="text-red-950/70 hover:text-red-600" href="/Recuperarcorreo">
                    ¿Has olvidado tu correo?
                  </a>
                  <a className="text-red-950/70 hover:text-red-600" href="/Login">
                    Ingresar
                  </a>
                </div>
              </div>
            </form>
          </div>
          </div>
        </div>
      </div>
    </>
  );
}
